<template>
  <AbsPopup id="SupportPopup" title="후원하기" @close="$emit('close')" @submit="submit" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <li>
          <span>글 제목 :{{ title }}</span>
        </li>
        <li>
          <span>필명 :{{ nic }}</span>
        </li>
        <span class="line"/>
        <div>
          <li class="pointbox" :class="{not: !isBuy}">
            <span>남은 포인트</span>
            <div>
              <span>{{ mypoint }}</span>
              <icon size="xsmall" uicon="edit_table"/>
            </div>
          </li>
          <li class="pointbox">
            <span>신청 포인트</span>
            <div>
              <span>-{{ supportpoint }}</span>
              <icon size="xsmall" uicon="edit_table"/>
            </div>
          </li>
        </div>
        <div class="inputSupport">
          <span>신청 포인트</span>
          <UInput type="text" placeholder="" v-model="supportpoint" align="center"/>
        </div>
        <div class="discription">
          <span>유펜비는 회원 상호 간 콘텐츠 거래를 위한 중개 시스템을 제공할 뿐, 회원을 대리하지 않습니다. 환급, 취소 등 회원 간 성리  된 거래에 대한 모든 책임은 회원이 직접 부담합니다. 자세한 내용은 서비스이용약관을 참고해주세요.</span>
        </div>
        <span class="line"/>
        <div>
          <span>작가에게 남기는 메시지 (댓글)</span>
          <span class="right">0/100</span>
        </div>
        <UInput class="comment" type="text" placeholder="작가님에 응원의 한마디를 남겨 주세요." v-model="comment" align="center"/>
        <TabBar class="publicBar" display="tabButton" :list="publicList" v-model="publicinit"/>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import TabBar from '@/components/layout/TabBar.vue'
import {numberToComma, commaToNumber} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.$http.post('/api/user/myInfo').then((row) => {
      console.log(row)
      if (row.success) {
        this.info = row
        this.$emit('loading', false)
      } else {
      }
    })
  },
  data: () => {
    return {
      info: null,
      supportpoint: '1,000',
      comment: '',
      publicinit: 0,
      publicList: [
        {name: '이름 공개', index: 0, tab: 'public'},
        {name: '이름 비공개', index: 1, tab: 'visible'}
      ]
    }
  },
  name: 'SupportPopup',
  watch: {
    supportpoint (val) {
      if (val === '') {
        this.supportpoint = numberToComma(0)
      } else if (commaToNumber(val) > 500000) {
        this.supportpoint = numberToComma(500000)
      } else {
        this.supportpoint = numberToComma(commaToNumber(val))
      }
    }
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: (this.isBuy) ? '후원하기' : '포인트가 부족합니다 충전하시겠습니까?', state: this.isSubmitState, click: this.submit}
      ]
    },
    title () {
      return this.option.param.book.title
    },
    nic () {
      return this.option.param.book.nic
    },
    isBuy () {
      if (this.info && this.option.param) {
        return Boolean(this.info.TotalPoint >= commaToNumber(this.supportpoint))
      }
      return false
    },
    isSubmitState () {
      if (this.isBuy) {
        return 'active'
      }
      return 'require'
    },
    mypoint () {
      if (this.info) {
        return numberToComma(this.info.TotalPoint)
      }
      return '0'
    },
    buypoint () {
      // return '-' + numberToComma(this.option.param.post.point)
      return '-'
    }
  },
  methods: {
    submit () {
      console.log('submit')
      if (this.isBuy) {
        this.$http.post('/api/point/support', {id: this.option.param.post._id, point: commaToNumber(this.supportpoint), state: this.publicinit}).then((row) => {
          console.log(row)
          if (row.success) {
            if (this.comment !== '') {
              this.$http.post('/api/comment/create', {book: this.option.param.book._id, post: this.option.param.post._id, text: this.comment, state: this.publicinit + 1}).then((e) => {
                console.log('comment', e)
                if (e.success) {
                  this.$center.dispatch('resetcomment')
                  this.$emit('submit')
                }
              })
            } else {
              this.$emit('submit')
            }
          } else {
          }
        })
      } else {
        this.openPopup('PointBuy', (e) => {
          console.log('PointBuy', e)
          if (e.success) {
          } else {
            this.info.TotalPoint = 20000
            // this.$emit('close')
          }
        })
      }
    }
  },
  components: {
    AbsPopup,
    UInput,
    TabBar
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 10px;
  width: 500px;
  text-align: left;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  color: var(--text-base);
}
.popup-body > li {
  display: flex;
  color: var(--text-title);
}
.popup-body .line {
  width: 100%;
  border-bottom: 1px solid var(--line-title);
  margin: 5px 0px;
}
.popup-body > div {
  display: flex;
  flex-direction: row;
  margin: 10px 0px;
}
.pointbox {
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid var(--line-title);
  padding: 5px;
  font-size: 18px;
  font-weight: bold;
  color: var(--text-title);
}
.pointbox.not {
  border: 1px solid var(--require);
}
.pointbox:first-child {
  margin-right: 5px;
}
.pointbox > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.popup-body .input {
  display: flex;
  flex-direction: row;
  flex: 1;
  border: 1px solid var(--line-guide);
  padding-left: 5px;
}
.popup-body .inputSupport {
  display: flex;
  flex-direction: row;
}
.popup-body .inputSupport span {
  margin-right: 5px;
}
.discription {
  border: 1px solid var(--line-guide);
  padding: 5px;
  line-height: 1.6;
}
.comment {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/SupportPopup.vue